import { EnvironmentProviders, Provider } from '@angular/core';

import { provideProvisioningDataAccess } from '@efficiently/client-data-access-provisioning';

export const provisioningProviders: (Provider | EnvironmentProviders)[] = [provideProvisioningDataAccess()];
